import React, { useEffect, useState } from 'react';
import BaseModal from '../baseModal';
import { useConnect } from '@stacks/connect-react';
import { principalCV } from '@stacks/transactions/dist/clarity/types/principalCV';
import { clientNetwork, stacksExplorer, stacksExplorerParam } from "../../lib/constants";
import TermsOfService from './TermsOfService';
import { network, authenticatedUserAddress } from "../../services/auth";
import { AnchorMode } from '@stacks/transactions';
import './style.scss';

function UserContractDeployModal({ show, setShow, txId, setTxId, userContractStatus, setUserContractStatus, openConfirmModal, setTx_Id, userSettings }) {
    const { doContractCall, doContractDeploy } = useConnect();
    const [openTerms, setOpenTerms] = useState(false);

    const userAddress = authenticatedUserAddress({ network: clientNetwork });

    async function deployUserContract() {
        const body = await (await fetch('/contracts/derupt-profile.clar')).text();
        doContractDeploy({
            contractName: 'derupt-profile',
            codeBody: body.toString(),
            anchorMode: AnchorMode.Any,
            network: network({ network: clientNetwork }),
            appappDetails: {
                name: 'Derupt',
                icon: window.location.origin + '/favicon.png',
            },
            onFinish: ({ txId: tx }) => {
                setTxId(tx);
                setTx_Id(tx);
                setOpenTerms(false);
                setUserContractStatus('mempool');
                openConfirmModal(true);
            }
        });
    }

    const userContractActivate = () => {
        const txOptions = {
            contractAddress: userAddress,
            contractName: 'derupt-profile',
            functionName: 'activate-member',
            functionArgs: [principalCV(`${userAddress}.derupt-profile`)],
            network: network({ network: clientNetwork }),
            onFinish: ({ txId: tx }) => {
                setTxId(tx);
                setTx_Id(tx);
                setOpenTerms(false);
                setUserContractStatus('activationPending');
                openConfirmModal(true);
            }
        }
        doContractCall(txOptions)
    }

    const handleClose = () => {
        setShow(false);
    }

    useEffect(()=>{
    }, [userContractStatus])

    return (
        <>
            <BaseModal show={show} setShow={setShow} handleClose={handleClose}>

                <div id="activate-deploy-form" className="broadcast-modal-tx__buttons">
                    {/* <p className='contract-deploy-text'>Your <a href='https://docs.derupt.io/latest/contracts/.derupt-profile' target='blank'>smart contract</a></p>
                    {userContractStatus === "notfound" ? <p className='contract-deploy-text'>is Ready to Deploy.</p> : null}
                    {userContractStatus === 'failed' ? <p className='contract-deploy-text'>Deployment failed, try again.</p> : null}
                    {userContractStatus === 'mempool' ? <p className='contract-deploy-text'>Deployment <a href={`${userSettings?.stacksExplorer || stacksExplorer}/txid/${txId}${stacksExplorerParam}`} target='blank'>pending</a>.</p> : null}
                    {userContractStatus === 'activationPending' ? <p className='contract-deploy-text'>Activation <a href={`${userSettings?.stacksExplorer || stacksExplorer}/txid/${txId}${stacksExplorerParam}`} target='blank'>pending</a>.</p> : null}
                    {userContractStatus === false ? <p className='contract-deploy-text'>is Ready to Activate.</p> : null}
                    <button className="button" disabled={userContractStatus === 'failed' || userContractStatus === 'notfound' ? false : true} onClick={() => setOpenTerms(true)} >Deploy</button>
                    <button className="button" disabled={userContractStatus ? true : false} onClick={() => setOpenTerms(true)} >Activate</button> */}
                    <h2 className='coming-soon'>Coming Soon</h2>
                </div>

            </BaseModal>
            {openTerms && <TermsOfService show={openTerms} close={() => setOpenTerms(false)} action={typeof (userContractStatus) === 'string' ? () => deployUserContract() : () => userContractActivate()} />}
        </>
    );
}
export default UserContractDeployModal;
